import { useQuery } from '@apollo/client';
import { Button, Modal, Text } from '@nextui-org/react';

import { gql } from '../generated';

interface InfoListItem {
  text: String;
  bookName: BookNameItem[];
}

interface BookNameItem {
  bookName: String;
  raviTitle: String;
  url: String;
}

interface InfoList {
  infoList: InfoListIndice[];
  infoList2: InfoListIndice2[];
}

interface InfoListIndice {
  text: InfoListItem[];
  title: String; //The type of info being displayed
}

interface InfoListIndice2 {
  text: String; //TODO: can be array
  title: String; //The type of info being displayed
}

const GET_NARRATOR_QUERY = gql(`
  query getNarrator($id: String) {
    narrator(id: $id) {
      data
    }
  }
`);

export default function NarratorInfo({
  visible,
  setNarratorInfoModalVisible,
  narratorId,
}: {
  visible: boolean;
  setNarratorInfoModalVisible: any;
  narratorId: any;
}) {
  const { data } = useQuery(GET_NARRATOR_QUERY, {
    variables: {
      id: String(narratorId),
    },
    skip: !narratorId,
  });

  return (
    <Modal closeButton aria-labelledby="modal-title" open={visible} onClose={() => setNarratorInfoModalVisible(false)}>
      <Modal.Header>
        <Text id="modal-title" size={18}>
          Narrator Information
        </Text>
      </Modal.Header>
      <Modal.Body style={{ alignItems: 'flex-end' }}>
        <Text className="mt-2" size={14}>
          <p>
            {data?.narrator?.data && data?.narrator?.data != '{}'
              ? JSON.parse(data?.narrator?.data || '').infoList?.map((c: InfoListIndice) => infoListComponent(c))
              : 'No data yet'}
          </p>
          <p>
            {data &&
              JSON.parse(data?.narrator?.data || '').infoList2?.map((c: InfoListIndice2) => infoListComponent2(c))}
          </p>
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button auto flat color="error" onPress={() => setNarratorInfoModalVisible(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function infoListComponent(infoListItem: InfoListIndice) {
  return (
    <>
      <h2 className="text-lg text-right tracking-arabic" dir="rtl" style={{ fontWeight: 'bold' }}>
        {infoListItem?.title.replace('ولادت', 'ولادة').replace(' در ثمانیه', '')}:
      </h2>
      {infoListItem.text.map((s) => infoListItemComponent(s))}
    </>
  );
}

function infoListItemComponent(infoListItem: InfoListItem) {
  var bookNames: String[] = [];
  infoListItem.bookName.map((s) => bookNames.push(s.bookName));
  return (
    <>
      <p className="text-1xl text-right tracking-arabic" dir="rtl">
        {infoListItem.text} ({bookNames.join(',')})
      </p>
    </>
  );
}

function infoListComponent2(infoListItem: InfoListIndice2) {
  if (infoListItem.title.includes('نتيجه ارزيابي') || infoListItem.title.includes('جمع بندي ارزيابي')) {
    return <></>;
  } else {
    return (
      <>
        <h2 className="text-lg text-right tracking-arabic" dir="rtl" style={{ fontWeight: 'bold' }}>
          {infoListItem.title.replace('الفاظ جرح و تعدیل', 'ألفاظ الجرح والتعديل')}:
        </h2>
        <p className="text-1xl text-right tracking-arabic" dir="rtl">
          {Array.isArray(infoListItem.text)
            ? infoListItem.text.map((s) => infoListItemComponent(s))
            : infoListItem.text}
        </p>
      </>
    );
  }
}
